import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Problem } from './components/Problem';
import { PackageContents } from './components/PackageContents';
import { MapGallery } from './components/MapGallery';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
import { metaPixelId } from './data/content';
export function App() {
  useMetaPixel(metaPixelId);
  return <div className="w-full bg-white" data-id="element-0" data-mp="31c9ygdv1bhw7">
      <main data-id="element-1" data-mp="2wk06ksad07ra">
        <Hero data-id="element-2" data-mp="2wjgrrkg09zhh" />
        <Stats data-id="element-3" data-mp="2wiyxuugtfxcq" />
        <Problem data-id="element-4" data-mp="2wj8g1vvmd07v" />
        <PackageContents data-id="element-5" data-mp="2wip36tktt20p" />
        <MapGallery data-id="element-6" data-mp="28ufoscpxzgjl" />
        <Bonuses data-id="element-7" data-mp="28tw972nrl48q" />
        <Pricing data-id="element-8" data-mp="28te3zgj4jfoo" />
        <Guarantee data-id="element-9" data-mp="28sur4e8bzhhi" />
        <Faq data-id="element-10" data-mp="28s2y9b64bxux" />
      </main>
      <Footer data-id="element-11" data-mp="23vkzcrxgytqi" />
    </div>;
}